import { RadixDialog } from '@/components/RadixDialog';
import CloseSvgIcon from '@/public/images/icons/close_icon.svg';
import styled from 'styled-components';

import { POPUP_MAX_WIDTH } from '../../../TwoPanelCenter/TwoPanelCenter.styles';

export const TrackingRightPanelWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.highEmphasisWhite};
  position: relative;
  
  @media (min-width: ${POPUP_MAX_WIDTH}px) {
     width: 528px;
  }
`;

export const PanelContent = styled.div(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto',
  background: theme.colors.highEmphasisWhite,
  wordBreak: 'break-word',
  padding: theme.spacing[20],

  '> :first-child': {
    width: '100%',
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    overflow: 'auto',
    padding: theme.spacing[40],
  },
}));

export const CloseIcon = styled(CloseSvgIcon).attrs({ width: 28, height: 28 })(({ theme }) => ({
  cursor: 'pointer',

  path: {
    fill: theme.colors.mediumEmphasisBlack,
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'block',
  },
}));

export const CloseIconWrapper = styled(RadixDialog.Close)(({ theme }) => ({
  position: 'absolute',
  top: 6,
  right: 6,
  cursor: 'pointer',
  width: 'fit-content',
  height: 'fit-content',
  border: 'none',
  background: 'none',
  padding: 0,
  margin: 0,
  display: 'none',

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: 'flex',
  },
}));
